"use client";
import {
  Box,
  Button,
  Grid2 as Grid,
  Paper,
  Popover,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { selectModule } from "../../../redux/slices/module.slice";
import { RootState } from "../../../redux/store/store";
import { getFilteredNavbarOptions } from "../../../routes/layouts/widget/constants";
import {
  dashboardButtonStyle,
  dashboardNavLinkStyle,
  footerContainerStyle,
  gridContainerStyle,
  moduleIconBoxStyle,
  moduleIconStyle,
  moduleNavLinkStyle,
  modulePaperStyle,
  moduleTitleStyle,
  popoverPaperProps,
} from "./widget/styles";

interface AppModulesPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  navbarOptions: any;
}

const AppModulesPopover = ({
  anchorEl,
  onClose,
  navbarOptions,
}: AppModulesPopoverProps) => {
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const { user } = useSelector((state: RootState) => state.auth);
  const userPermissions = useSelector(
    (state: RootState) => state.auth.permissions,
  );
  const isEmployerRole = user?.roleType === "EMPLOYER";

  const filteredNavbarOptions = getFilteredNavbarOptions(
    navbarOptions,
    userPermissions,
    user, // Pass user for custom permission checks
  );

  const handleModuleClick = (moduleValue: string) => {
    dispatch(selectModule(moduleValue));
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      PaperProps={{
        sx: popoverPaperProps,
      }}
    >
      <Box sx={gridContainerStyle}>
        <Grid container spacing={2}>
          {Object.values(filteredNavbarOptions)
            .filter((module: any) => {
              if (isEmployerRole) {
                return module.value === "EMPLOYER_PORTAL";
              }
              return module.value !== "EMPLOYER_PORTAL";
            })
            .filter((module: any) => {
              if (isEmployerRole) {
                return module.value === "AFFILIATE_PORTAL";
              }
              return module.value !== "AFFILIATE_PORTAL";
            })
            .filter((module: any) => {
              if (isEmployerRole) {
                return module.value === "BROKER_PORTAL";
              }
              return module.value !== "BROKER_PORTAL";
            })
            .map((module: any) => {
              return (
                <Grid size={4} key={module.value}>
                  <NavLink
                    to={module.path}
                    onClick={() => handleModuleClick(module.value)}
                    style={moduleNavLinkStyle}
                  >
                    <Paper elevation={1} sx={modulePaperStyle}>
                      <Box sx={moduleIconBoxStyle}>
                        <img
                          src={module.icon || "/placeholder.svg"}
                          alt={module.title}
                          style={moduleIconStyle}
                        />
                      </Box>
                      <Typography variant="body2" sx={moduleTitleStyle}>
                        {module.title}
                      </Typography>
                    </Paper>
                  </NavLink>
                </Grid>
              );
            })}
        </Grid>
      </Box>
      <Box sx={footerContainerStyle}>
        {!isEmployerRole && (
          <NavLink to="/" style={dashboardNavLinkStyle}>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              sx={dashboardButtonStyle}
            >
              View Master Dashboard
            </Button>
          </NavLink>
        )}
      </Box>
    </Popover>
  );
};

export default AppModulesPopover;
